"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoIndicatorSeparator = exports.DropdownIndicator = exports.ClearIndicator = exports.MultiValueRemove = exports.MultiValueLabel = exports.MultiValueContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_select_1 = require("react-select");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("../../../icons");
// react-select internal component replacements
// ------------------------------------------------------------------
// Chip / Multi Value
// add color classes to chip, see chip-options.js for options array examples
var MultiValueContainer = function (_a) {
    var innerProps = _a.innerProps, props = __rest(_a, ["innerProps"]);
    var _b = props.data, _c = _b.color, color = _c === void 0 ? 'neutral' : _c, variant = _b.variant;
    innerProps.className = (0, classnames_1.default)('chip', variant ? "chip-".concat(variant, "-").concat(color) : "chip-".concat(color));
    return (0, jsx_runtime_1.jsx)(react_select_1.components.MultiValueContainer, __assign({}, props, { innerProps: innerProps }));
};
exports.MultiValueContainer = MultiValueContainer;
// add icon to chip label
var MultiValueLabel = function (_a) {
    var children = _a.children, innerProps = _a.innerProps, props = __rest(_a, ["children", "innerProps"]);
    var _b = props.data, Icon = _b.icon, color = _b.color, variant = _b.variant, darkIcon = _b.darkIcon;
    innerProps.className = 'chip-label';
    // neutral icon color override for default and bordered chips
    var iconClasses = (0, classnames_1.default)('chip-icon-prefix', {
        'text-default': variant !== 'solid' && (color === 'neutral' || darkIcon),
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [Icon && (0, jsx_runtime_1.jsx)(Icon, { className: iconClasses }), (0, jsx_runtime_1.jsx)(react_select_1.components.MultiValueLabel, __assign({}, props, { innerProps: innerProps }, { children: children }))] }));
};
exports.MultiValueLabel = MultiValueLabel;
// replace X icon for chip
var MultiValueRemove = function (_a) {
    var innerProps = _a.innerProps, props = __rest(_a, ["innerProps"]);
    innerProps.className = 'btn-close-inline chip-remove rounded-circle';
    return ((0, jsx_runtime_1.jsx)(react_select_1.components.MultiValueRemove, __assign({}, props, { innerProps: innerProps }, { children: (0, jsx_runtime_1.jsx)(icons_1.Remove16, {}) })));
};
exports.MultiValueRemove = MultiValueRemove;
// ------------------------------------------------------------------
// replace clear indicator X icon
var ClearIndicator = function (props) { return ((0, jsx_runtime_1.jsx)(react_select_1.components.ClearIndicator, __assign({}, props, { children: (0, jsx_runtime_1.jsx)(icons_1.Remove16, { style: { width: '20px', height: '20px' } }) }))); };
exports.ClearIndicator = ClearIndicator;
// replace clear indicator X icon
var DropdownIndicator = function (props) { return ((0, jsx_runtime_1.jsx)(react_select_1.components.DropdownIndicator, __assign({}, props, { children: (0, jsx_runtime_1.jsx)(icons_1.Down16, { style: { width: '20px', height: '20px' } }) }))); };
exports.DropdownIndicator = DropdownIndicator;
exports.default = {
    MultiValueContainer: exports.MultiValueContainer,
    MultiValueLabel: exports.MultiValueLabel,
    MultiValueRemove: exports.MultiValueRemove,
    ClearIndicator: exports.ClearIndicator,
    DropdownIndicator: exports.DropdownIndicator,
};
var NoIndicatorSeparator = function () { return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}); };
exports.NoIndicatorSeparator = NoIndicatorSeparator;
